import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const parseSafely = <T>(str: any, defaultValue: any = {}) => {
  try {
    return JSON.parse(str) as T;
  } catch (err) {
    return defaultValue;
  }
};

export const fromUnderscoreToTitleCase = (str: string): string => {
  return (
    str
      ?.split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ") ?? ""
  );
};

export function floatTo16BitPCM(float32: Float32Array): Int16Array {
  const pcm16 = new Int16Array(float32.length);
  for (let i = 0; i < float32.length; i++) {
    const s = Math.max(-1, Math.min(1, float32[i]));
    pcm16[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
  }
  return pcm16;
}

export function int16ToBase64(pcm16: Int16Array): string {
  const bytes = new Uint8Array(pcm16.buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export function pickDefined<T extends Record<string, unknown>>(
  obj: T
): { [K in keyof T]: Exclude<T[K], undefined | null | ""> } {
  const result = {} as { [K in keyof T]: Exclude<T[K], undefined | null | ""> };
  for (const key in obj) {
    const value = obj[key];
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value as Exclude<T[typeof key], undefined | null | "">;
    }
  }
  return result;
}
